import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { searched } from "../../features/filter/filterSlice";

const Search = () => {
    const { searchText } = useSelector((state) => state.filter);
    const dispatch = useDispatch();
    const [input, setInput] = useState(searchText);
    const location = useLocation();
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();

        dispatch(searched(input));
        setInput("");

        //if user not in home page, redirect him to home page
        if (location?.pathname !== "/") {
            navigate("/");
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <input
                className="outline-none border-none mr-2"
                type="search"
                name="search"
                placeholder="Search"
                value={input}
                onChange={(e) => setInput(e.target.value)}
            />
        </form>
    );
};

export default Search;
